import { tsInitVue } from './js-utils'

document.addEventListener('DOMContentLoaded', function () {
  const importManagerEl = document.querySelector('div[data-is="EventsImportManager"]')
  if (importManagerEl instanceof HTMLElement) {
    (async (): Promise<void> => {
      // eslint-disable-next-line @typescript-eslint/naming-convention
      const EventsImportManager = await import('../js/vue-components/events-import-manager.vue')
      window.eventsImportManager = tsInitVue(EventsImportManager.default, importManagerEl, {
        listUrl: importManagerEl.dataset.listUrl,
        importUrl: importManagerEl.dataset.importUrl,
        returnToTitle: importManagerEl.dataset.returnToTitle,
        returnToUrl: importManagerEl.dataset.returnToUrl,
      })
    })()
  }
})
